import React from "react";
import { useApiClient } from "../../../../shared/customHooks";
import { useApplicationContext } from "../../context/applicationContext";
import { applicationTypeLegacyForm } from "../../../../shared/formObjects/application/legacy/applicationTypeLegacyForm";
import BaseApplicationComponent from "../../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";

function ApplicationTypeComponentLegacy({ disabled, data }: any) {
  const api = useApiClient("ApplicationTypeLegacy");
  const { id } = useApplicationContext();

  return (
    <BaseApplicationComponent
      formBody={applicationTypeLegacyForm}
      headerLabel="Type of Application"
      editPath="applicationtype"
      apiClient={api}
      disabled={disabled}
      data={data}
      id={id}
    />
  );
}

export default ApplicationTypeComponentLegacy;
